import 'babel-polyfill';
import App from 'App';

/* eslint-disable no-unused-vars */
window.app = new App(window);
/* eslint-enable no-unused-vars */
